import { createSelector } from '@ngrx/store';
import { CardStatus } from 'src/graphql/generated/graphql.generated';
import { selectAllCards, selectAllOperations, selectAllUnits } from './entity-store-selectors';

export const selectNull = <TOut>() =>
  createSelector({} as any, () => undefined as TOut | undefined);

export function selectOperationByCardNumber(cardNumber: string) {
  return createSelector(selectAllCards, selectAllOperations, (cards, operations) =>
    cards.find((c) => c.cardNumber === cardNumber) == null
      ? undefined
      : operations.find((operation) => {
          const card = cards.find((c) => c.cardNumber === cardNumber);
          return card == null ? false : operation.id === card.operationId;
        }),
  );
}

export function selectOperationByCardId(cardId: string) {
  return createSelector(selectAllCards, selectAllOperations, (cards, operations) =>
    cards.find((c) => c.id === cardId) == null
      ? undefined
      : operations.find((operation) => {
          const card = cards.find((c) => c.id === cardId);
          return card == null ? false : operation.id === card.operationId;
        }),
  );
}

export function selectOpenOperationsForRegion(regionId: string) {
  return createSelector(
    selectAllUnits,
    selectAllOperations,
    selectAllCards,
    (units, operations, cards) => {
      return operations
        .valueSeq()
        .filter(
          (o) =>
            units.find((u) => u.id === o.unitId && u.regionId === regionId) != null &&
            cards
              .valueSeq()
              .find(
                (c) =>
                  c.operationId === o.id &&
                  c.status !== CardStatus.Completed &&
                  c.status !== CardStatus.Closed,
              ) != null,
        );
    },
  );
}
